import React from "react"

const FormFields = React.memo(function FormFields({ formData, onInputChange }) {
  return (
    <div className="form-fields">
      {/* Service Title Field */}
      <div className="field-group">
        <label htmlFor="title" className="field-label">
          Service Title
        </label>
        <input
          id="title"
          type="text"
          name="title"
          value={formData.title}
          onChange={onInputChange}
          placeholder="Enter service title"
          className="field-input"
        />
      </div>

      {/* Service Subtitle Field */}
      <div className="field-group">
        <label htmlFor="subtitle" className="field-label">
          Service Subtitle
        </label>
        <input
          id="subtitle"
          type="text"
          name="subtitle"
          value={formData.subtitle}
          onChange={onInputChange}
          placeholder="Enter service subtitle"
          className="field-input"
        />
      </div>

      {/* Service Content Field */}
      <div className="field-group">
        <label htmlFor="content" className="field-label">
          Service Content
        </label>
        <textarea
          id="content"
          name="content"
          value={formData.content}
          onChange={onInputChange}
          placeholder="Enter detailed service description..."
          className="field-textarea"
        />
        <p className="field-hint">Provide a detailed description of the service</p>
      </div>
    </div>
  )
})

export default FormFields
